import Vue from "vue";
// import Router from "vue-router";

import VueRouter from 'vue-router'

import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
// import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
// import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";


import Hero from "./views/components/Hero.vue"
import Urlshort from "./views/Urlshort.vue";
import Share from "./views/Share.vue";
import Clouddownload from "./views/Clouddownload.vue"
import Filelist from "./views/Filelist.vue"

// // import axios from 'axios'
// // import VueAxios from 'vue-axios'
// Vue.use(Router);
// // Vue.use(VueAxios, axios)
// export default new Router({
//     linkExactActiveClass: "active",
//     routes: [
//         {
//             path: "/",
//             name: "components",
//             components: {
//                 header: AppHeader,
//                 default: Hero,
//                 footer: AppFooter
//             }
//         },
//         {
//             path: "/landing",
//             name: "landing",
//             components: {
//                 header: AppHeader,
//                 default: Landing,
//                 footer: AppFooter
//             }
//         },
//         {
//             path: "/login",
//             name: "login",
//             components: {
//                 header: AppHeader,
//                 default: Login,
//                 footer: AppFooter
//             }
//         },
//         // {
//         //     path: "/register",
//         //     name: "register",
//         //     components: {
//         //         header: AppHeader,
//         //         default: Register,
//         //         footer: AppFooter
//         //     }
//         // },
//         {
//             path: "/profile",
//             name: "profile",
//             components: {
//                 header: AppHeader,
//                 default: Profile,
//                 footer: AppFooter
//             }
//         },
//         {
//             path: "/urlshort",
//             name: "urlshort",
//             components: {
//                 header: AppHeader,
//                 default: Urlshort,
//                 footer: AppFooter
//             }
//         },
//         {
//             path: "/share",
//             name: "share",
//             components: {
//                 header: AppHeader,
//                 default: Share,
//                 footer: AppFooter
//             }
//         },
//         {
//             path: "/clouddownload",
//             name: "clouddownload",
//             components: {
//                 header: AppHeader,
//                 default: Clouddownload,
//                 footer: AppFooter
//             }
//         },
//         {
//             path: "/*",
//             name: "filelist",
//             components: {
//                 header: AppHeader,
//                 default: Filelist,
//                 footer: AppFooter
//             }
//         }
//     ],
//     scrollBehavior: to => {
//         if (to.hash) {
//             return {selector: to.hash};
//         } else {
//             return {x: 0, y: 0};
//         }
//     }
// });
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'components',
        components: {
                header: AppHeader,
                default: Hero,
                footer: AppFooter
            }
    },
    {
        path: "/landing",
        name: "landing",
        components: {
            header: AppHeader,
            default: Landing,
            footer: AppFooter
        }
    },
    {
        path: "/login",
        name: "login",
        components: {
            header: AppHeader,
            default: Login,
            footer: AppFooter
        }
    },
    {
        path: "/urlshort",
        name: "urlshort",
        components: {
            header: AppHeader,
            default: Urlshort,
            footer: AppFooter
        }
    },
    {
        path: "/share",
        name: "share",
        components: {
            header: AppHeader,
            default: Share,
            footer: AppFooter
        }
    },
    {
        path: "/clouddownload",
        name: "clouddownload",
        components: {
            header: AppHeader,
            default: Clouddownload,
            footer: AppFooter
        }
    },
    {
        path: "/*",
        name: "filelist",
        components: {
            header: AppHeader,
            default: Filelist,
            footer: AppFooter
        }
    }

    // {
    //     path: '/',
    //     name: 'home',
    //     redirect: 'index',
    //     component: () => import('../views/Home.vue'),
    //     children: [
    //         {
    //             path: 'document',
    //             name: 'document',
    //             component: () => import('../views/Document.vue')
    //         },
    //     ]
    // }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 添加路由守卫
// router.beforeEach((to, from, next) => {
//     const isLogin = !!localStorage.eleToken
//     if (to.path === '/login') {
//         next()
//     } else {
//         isLogin ? next() : next('/login')
//     }
// })

export default router